import request from '@/utils/request';

async function baseRequest(path, payload, method) {
  return request({
    url: `/place-service/${path}`,
    method,
    data: method === 'get' ? null : payload,
    params: method === 'get' ? payload : null,
  });
}

export function queryCustomerList(payload) {
  return baseRequest('getCustomers', payload, 'get');
}

export function bulkCreatePlace(payload) {
  return baseRequest('bulkCreatePlace', payload, 'post');
}

export function fetchplaceList(payload) {
  return baseRequest('places', payload, 'get');
}

export function getPlace(payload) {
  return baseRequest(`place/${payload.id}`, null, 'get');
}

export function getPlacesInfo(payload) {
  return baseRequest('getPlacesInfo', payload, 'get');
}

export function getAllFloors(payload) {
  return baseRequest('floors/all', payload, 'get');
}

export function getAllPlaces(payload) {
  return baseRequest('places/all', payload, 'get');
}

export function packageList(params) {
  return request({
    url: '/deployment-service/offline_package/list',
    method: 'get',
    params,
  });
}
export function createData(data) {
  return request({
    url: '/deployment-service/offline_package/create_data',
    method: 'POST',
    data,
  });
}
export function updateData(data) {
  return request({
    url: '/deployment-service/offline_package/update_status_data',
    method: 'POST',
    data,
  });
}
export function downloadUrl(params) {
  return request({
    url: '/deployment-service/offline_package/download_url',
    method: 'get',
    params,
  });
}

export function updateVR(params) {
  return request({
    url: '/deployment-service/floor/update-vr',
    method: 'get',
    params,
  });
}

export function getGroupList() {
  return request({
    url: '/deployment-service/place_group_type/list',
    method: 'get',
  });
}

export function getGroupIdByPlaceId(placeId) {
  return request({
    url: `/deployment-service/place_group_type/list?place_id=${placeId}`,
    method: 'get',
  });
}

export function createGroup(data) {
  return request({
    url: '/deployment-service/place_group_type/create',
    method: 'POST',
    data,
  });
}
export function updateGroup(data) {
  return request({
    url: `/deployment-service/place_group_type/update/${data.id}`,
    method: 'POST',
    data,
  });
}
export function updateFloorInfo(data) {
  return request({
    url: '/place-service/updateFloorInfo',
    method: 'POST',
    data,
  });
}

export function syncFloorAndSite(data) {
  return request({
    baseURL: '/bmap',
    url: '/parking/saveSite',
    method: 'POST',
    data,
  });
}
